export default __webpack_public_path__ + "static/media/error.9a6de6e1.gif";